export const BASE_SEPOLIA_E2E_ACCOUNT_ADDRESS = '0x4252e0c9A3da5A2700e7d91cb50aEf522D0C6Fe8';
export const SOLANA_DEVNET_E2E_ACCOUNT_ADDRESS = 'EeVPcnRE1mhcY85wAh3uPJG1uFiTNya9dCJjNUPABXzo';
